module.exports = __webpack_public_path__ + "static/media/noBestDish1.4c40bd8d.png";